module.exports = __webpack_public_path__ + "static/barbells-547a2f416f183a8e6ca1dd2dd5b0458e.svg";